/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/folder_medium'
export default icon
